/* Thunderpilz – Theme-Interaktionen (vanilla, Shopify AJAX Cart) */
(function () {
  'use strict';

  var FREE_SHIP_THRESHOLD = 10000; // Cent – synchron mit Versand-Logik halten (TODO: an echte Schwelle koppeln)

  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Header: sticky-Schatten ---------- */
  function initStickyHeader() {
    var h = $('.site-header');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mega-Menü ---------- */
  function initMega() {
    var header = $('.site-header');
    if (!header) return;
    var triggers = $all('[data-mega-trigger]');
    var megas = $all('[data-mega]');
    function closeAll() {
      megas.forEach(function (m) { m.classList.remove('is-open'); });
      triggers.forEach(function (t) { t.classList.remove('is-open'); });
    }
    function open(name) {
      closeAll();
      var m = $('[data-mega="' + name + '"]');
      var t = $('[data-mega-trigger="' + name + '"]');
      if (m) m.classList.add('is-open');
      if (t) t.classList.add('is-open');
    }
    triggers.forEach(function (t) {
      t.addEventListener('mouseenter', function () { open(t.getAttribute('data-mega-trigger')); });
    });
    $all('[data-mega-close]').forEach(function (el) {
      el.addEventListener('mouseenter', closeAll);
    });
    header.addEventListener('mouseleave', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------- Such-Overlay ---------- */
  function initSearch() {
    var overlay = $('[data-search-overlay]');
    if (!overlay) return;
    var input = overlay.querySelector('input[type="search"], input[type="text"]');
    function open() { overlay.classList.add('is-open'); if (input) setTimeout(function () { input.focus(); }, 60); }
    function close() { overlay.classList.remove('is-open'); }
    $all('[data-search-toggle]').forEach(function (b) { b.addEventListener('click', open); });
    $all('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Mobile-Nav ---------- */
  function initMobileNav() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    function open() { nav.classList.add('is-open'); }
    function close() { nav.classList.remove('is-open'); }
    $all('[data-mobile-toggle]').forEach(function (b) { b.addEventListener('click', function () { nav.classList.toggle('is-open'); }); });
    $all('[data-mobile-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Cookie-Banner ---------- */
  function initCookie() {
    var c = $('[data-cookie]');
    if (!c) return;
    try { if (!localStorage.getItem('tp_cookie')) c.classList.add('is-open'); } catch (e) {}
    function accept(level) { try { localStorage.setItem('tp_cookie', level); } catch (e) {} c.classList.remove('is-open'); }
    $all('[data-cookie-all]').forEach(function (b) { b.addEventListener('click', function () { accept('all'); }); });
    $all('[data-cookie-nec]').forEach(function (b) { b.addEventListener('click', function () { accept('necessary'); }); });
  }

  /* ---------- Warenkorb-Drawer ---------- */
  var Cart = {
    open: function () { var d = $('[data-cart-drawer]'); var b = $('[data-cart-backdrop]'); if (d) d.classList.add('is-open'); if (b) b.classList.add('is-open'); },
    close: function () { var d = $('[data-cart-drawer]'); var b = $('[data-cart-backdrop]'); if (d) d.classList.remove('is-open'); if (b) b.classList.remove('is-open'); },
    fetch: function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); },
    render: function (cart) {
      var count = cart.item_count;
      $all('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      var head = $('[data-cart-headcount]'); if (head) head.textContent = '(' + count + ')';
      var body = $('[data-cart-body]');
      if (body) {
        if (!cart.items.length) {
          body.innerHTML = '<div class="cart-empty"><div class="ph ph--free"></div><p>Dein Warenkorb ist noch leer.</p><a class="btn btn--dark" href="/collections/all" data-cart-close style="margin-top:18px;">Produkte entdecken</a></div>';
        } else {
          body.innerHTML = cart.items.map(function (it) {
            var img = it.image ? '<img src="' + it.image + '" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;">' : '';
            var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
            return '' +
              '<div class="cart-line" data-line-key="' + it.key + '">' +
                '<div class="ph">' + img + '</div>' +
                '<div>' +
                  '<div class="cl-title">' + it.product_title + '</div>' +
                  (variant ? '<div class="cl-variant">' + variant + '</div>' : '') +
                  '<div class="qty">' +
                    '<button data-qty-dec aria-label="weniger">−</button>' +
                    '<span>' + it.quantity + '</span>' +
                    '<button data-qty-inc aria-label="mehr">+</button>' +
                  '</div>' +
                '</div>' +
                '<div class="cl-right">' +
                  '<div class="cl-price">' + euro(it.final_line_price) + '</div>' +
                  '<button class="cl-remove" data-qty-remove>Entfernen</button>' +
                '</div>' +
              '</div>';
          }).join('');
        }
      }
      $all('[data-cart-subtotal]').forEach(function (el) { el.textContent = euro(cart.total_price); });
      // Gratisversand-Fortschritt
      var remaining = Math.max(0, FREE_SHIP_THRESHOLD - cart.total_price);
      var pct = cart.total_price <= 0 ? 0 : Math.min(100, cart.total_price / FREE_SHIP_THRESHOLD * 100);
      var fill = $('[data-ship-fill]'); if (fill) fill.style.width = pct + '%';
      var msg = $('[data-ship-msg]');
      if (msg) {
        msg.innerHTML = (remaining <= 0 && cart.total_price > 0)
          ? '<strong>Geschafft – du erhältst Gratisversand.</strong>'
          : 'Noch <strong>' + euro(remaining) + '</strong> bis zum kostenlosen Versand';
      }
      this.bindLines();
    },
    refresh: function () { var self = this; return this.fetch().then(function (c) { self.render(c); return c; }); },
    change: function (key, qty) {
      var self = this;
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) { self.render(c); return c; });
    },
    add: function (formOrId, qty) {
      var self = this;
      var payload;
      if (typeof formOrId === 'object' && formOrId.tagName === 'FORM') {
        payload = new FormData(formOrId);
      } else {
        payload = JSON.stringify({ items: [{ id: formOrId, quantity: qty || 1 }] });
      }
      var opts = (payload instanceof FormData)
        ? { method: 'POST', headers: { 'Accept': 'application/json' }, body: payload }
        : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: payload };
      return fetch('/cart/add.js', opts).then(function (r) { return r.json(); }).then(function (res) {
        return self.refresh().then(function () { self.open(); return res; });
      });
    },
    bindLines: function () {
      var self = this;
      $all('[data-cart-body] .cart-line').forEach(function (line) {
        var key = line.getAttribute('data-line-key');
        var qtyEl = line.querySelector('.qty span');
        var q = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var inc = line.querySelector('[data-qty-inc]');
        var dec = line.querySelector('[data-qty-dec]');
        var rm = line.querySelector('[data-qty-remove]');
        if (inc) inc.addEventListener('click', function () { self.change(key, q + 1); });
        if (dec) dec.addEventListener('click', function () { self.change(key, q - 1); });
        if (rm) rm.addEventListener('click', function () { self.change(key, 0); });
      });
      $all('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
    }
  };

  function initCart() {
    $all('[data-cart-toggle]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); Cart.open(); }); });
    $all('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { Cart.close(); }); });
    var backdrop = $('[data-cart-backdrop]'); if (backdrop) backdrop.addEventListener('click', function () { Cart.close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });

    // Add-to-cart Formulare (PDP) + Buttons (Karten)
    $all('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); Cart.add(form); });
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-add-variant]') : null;
      if (btn) { e.preventDefault(); Cart.add(btn.getAttribute('data-add-variant'), 1); }
    });

    Cart.refresh();
  }
  window.TPCart = Cart;

  /* ---------- Fehlende Bild-Assets: sauber auf .ph-Platzhalter zurückfallen ---------- */
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') { t.style.display = 'none'; }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initMega();
    initSearch();
    initMobileNav();
    initCookie();
    initCart();
  });
})();
